import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./invoice.css";

export default function InvoiceGenerator() {
  const navigate = useNavigate(); // 🔐 For redirect

  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();

  const [month, setMonth] = useState(currentMonth - 1);
  const [year, setYear] = useState(currentYear);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState("Idle");
  const [result, setResult] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL ;

  const months = [
    { v: 1, t: "January" }, { v: 2, t: "February" }, { v: 3, t: "March" },
    { v: 4, t: "April" },   { v: 5, t: "May" },      { v: 6, t: "June" },
    { v: 7, t: "July" },    { v: 8, t: "August" },   { v: 9, t: "September" },
    { v: 10, t: "October" },{ v: 11, t: "November" },{ v: 12, t: "December" }
  ];

  // Allowed years: last 5 years until current
  const allowedYears = [];
  for (let y = currentYear - 5; y <= currentYear; y++) {
    allowedYears.push(y);
  }

  // Month logic
  const filteredMonths =
    Number(year) === currentYear
      ? months.filter((m) => m.v < currentMonth)
      : months;

  // 🔐 Logout Function
  const handleLogout = () => {
  console.log("Logging out...");
  localStorage.removeItem("auth");

  // Force full reload so App.js re-checks auth
  window.location.replace("/");
};

  const handleGenerate = async () => {
    if (!month || !year) {
      toast.error("Select valid month & year");
      return;
    }

    setLoading(true);
    setProgress("Requesting invoice data...");

    try {
      const resp = await fetch(
        `${API_URL}/download?report_month=${month}&report_year=${year}`
      );

      if (!resp.ok) throw new Error("Failed to generate invoice");

      setProgress("Preparing download...");

      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice_${month}_${year}.xlsx`;
      link.click();

      toast.success("Invoice downloaded!");
      setProgress("Completed");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="invoice-wrapper">
      <div className="invoice-card">


        <h2 className="title">Generate Monthly Invoice</h2>

        <div className="input-row">
          <select
            className="input-select"
            value={month}
            onChange={(e) => setMonth(Number(e.target.value))}
          >
            {filteredMonths.map((m) => (
              <option key={m.v} value={m.v}>
                {m.t}
              </option>
            ))}
          </select>

          <select
            className="input-select"
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
          >
            {allowedYears.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>

          <button
            className="btn-generate"
            onClick={handleGenerate}
            disabled={loading}
          >
            {loading ? <div className="spinner"></div> : "Generate"}
          </button>
        </div>

        {/* Progress */}
        <div className="progress-box">
          <div className="progress-label">
            <b>Progress:</b> {progress}
          </div>
          {loading && <div className="progress-bar"></div>}
        </div>
        
        {/* 🔐 Logout Button */}
        <div className="logout-container">
          <button className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-4 rounded-lg transition duration-200 shadow-md mt-6" onClick={handleLogout}>
            Logout
          </button>
        </div>

        {/* Result JSON */}
        {result && (
          <div className="result-box">
            <h4>Response</h4>
            <pre>{JSON.stringify(result, null, 2)}</pre>
          </div>
        )}
      </div>

      <ToastContainer position="top-right" autoClose={1800} />
    </div>
  );
}